
import { Button, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup, TextField } from "@mui/material";
import { Typography } from "components/ui";
import React from "react";
import { ContainerStyle } from "../styled";

const BottleJoin = ({ roomCode, setRoomCode, userName, setUserName, drinkType, setDrinkType, userQuestion, setUserQuestion, handleJoinRoom }) => {
    return (
        <ContainerStyle sx={{ pt: 5, textAlign: "center" }}>
            <Typography $bolds $size="2.5em" color="primary">
                🍾 Spin Bottle
            </Typography>
            <Paper
                elevation={3}
                sx={{
                    mt: 4,
                    p: 4,
                    borderRadius: 4,
                    maxWidth: 500,
                    mx: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <TextField
                    label="Room Code"
                    value={roomCode}
                    onChange={(e) => setRoomCode(e.target.value)}
                    fullWidth
                    variant="outlined"
                />
                <TextField
                    label="ชื่อของคุณ"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    fullWidth
                />
                <FormControl component="fieldset" sx={{ textAlign: "left" }}>
                    <FormLabel>เลือกสายดื่ม</FormLabel>
                    <RadioGroup
                        row
                        value={drinkType}
                        onChange={(e) => setDrinkType(e.target.value)}
                    >
                        <FormControlLabel value="เหล้า" control={<Radio />} label="เหล้า" />
                        <FormControlLabel value="เบียร์" control={<Radio color="success" />} label="เบียร์" />
                    </RadioGroup>
                </FormControl>
                <TextField
                    label="ฝากคำถาม (Optional)"
                    multiline
                    rows={2}
                    value={userQuestion}
                    onChange={(e) => setUserQuestion(e.target.value)}
                    fullWidth
                    placeholder="คำถามจะถูกใส่ลงไปในขวด..."
                />
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleJoinRoom}
                    sx={{ py: 1.5, borderRadius: 2 }}
                >
                    JOIN ROOM
                </Button>
            </Paper>
        </ContainerStyle>
    );
};

export default BottleJoin;
